"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VEICULOS = exports.VEICULOS_ESPECIES = exports.VEICULOS_RESTRICOES = exports.VEICULOS_COMBUSTIVEIS = exports.VEICULOS_TIPOS = exports.VEICULOS_CATEGORIAS = exports.VEICULOS_CARROCERIAS = exports.CNH_CATEGORIAS = void 0;
exports.CNH_CATEGORIAS = ["A", "AB", "B", "C", "D", "E", "ACC", "MOTOR-CASA"];
exports.VEICULOS_CARROCERIAS = ["AMBULÂNCIA", "BASCULANTE", "BLINDADA", "BUGGY", "C. FECHADA", "CAB. DUPLA", "CAB. ABERTA",
    "CONVERSÍVEL", "FURGÃO", "JIPE", "TRAILER"];
exports.VEICULOS_CATEGORIAS = ["ALUGUEL", "APRENDIZAGEM", "PARTICULAR"];
exports.VEICULOS_TIPOS = ["AUTOMÓVEL", "CAMINHÃO", "CAMINHONETA", "CARGA / CAM", "CICLOMOTO", "ESP / ÔNIBUS", "MICROÔNIBUS",
    "MISTO / CAM", "MOTOCICLO", "MOTONETA", "ÔNIBUS", "REBOQUE", "TRICICLO", "C. TRATOR"];
exports.VEICULOS_COMBUSTIVEIS = ["ÁLCOOL", "ÁLCOOL / GNC", "DIESEL", "DIESEL / GNC", "ELFONT EX", "ELFONT IN", "GÁS METANO",
    "GASOGÊNIO", "GASOL / GNC", "GASOLINA", "ÁLCOOL / GASOLINA", "ÁLCOOL / GASOL / GNV"];
exports.VEICULOS_RESTRICOES = ["ALIENAÇÃO FIDUCIÁRIA", "ARRENDAMENTO", "RESERVA DE DOMÍNIO", "RESTRIÇÃO JUDICIAL",
    "RESTRIÇÃO POR BENEF. TRIBUTÁRIO", "RESTRIÇÃO POR ROUBO OU FURTO"];
exports.VEICULOS_ESPECIES = ["CARGA", "CORRIDA", "ESPECIAL", "MISTO", "PASSAGEIRO", "TRAÇÃO"];
exports.VEICULOS = [
    { "modelo": "100 2.8 V6", "marca": "Audi" },
    { "modelo": "A3 Sportback 2.0 16V TFSI S-Tronic", "marca": "Audi" },
    { "modelo": "A4 1.8  Aut.", "marca": "Audi" },
    { "modelo": "320iA 2.0 TB M Sport ActiveFlex 16V 4p", "marca": "BMW" },
    { "modelo": "325i", "marca": "BMW" },
    { "modelo": "420i Cabriolet Sport 2.0 TB 184cv 2p", "marca": "BMW" },
    { "modelo": "550iA Limited Sport Edition 4.8 32V", "marca": "BMW" },
    { "modelo": "840Ci", "marca": "BMW" },
    { "modelo": "i3 Rex E Drive Full 170cv Aut.(Elétrico)", "marca": "BMW" },
    { "modelo": "M3 Sedan 4.0 32V", "marca": "BMW" },
    { "modelo": "M4 Cabriolet 3.0 Bi-Turbo 24V 431cv 2p", "marca": "BMW" },
    { "modelo": "M5 3.8/Touring 3.8 24V", "marca": "BMW" },
    { "modelo": "M6 5.0 V10 40V 507cv", "marca": "BMW" },
    { "modelo": "X4 XDRIVE 28i X-Line 2.0 Turbo 245cv Aut", "marca": "BMW" },
    { "modelo": "X4 XDRIVE 35i M-Sport 3.0 TB 306cv Aut.", "marca": "BMW" },
    { "modelo": "X5 3.0 4x4", "marca": "BMW" },
    { "modelo": "Z4 Roadster Sport 3.0 24V 231cv Aut.", "marca": "BMW" },
    { "modelo": "Z8 5.0 V8", "marca": "BMW" },
    { "modelo": "AIRCROSS Exc. ATACA. 1.6 Flex 16V 5p Aut", "marca": "Citroën" },
    { "modelo": "AX GTi", "marca": "Citroën" },
    { "modelo": "C3 XTR 1.6 Flex 16V 5p", "marca": "Citroën" },
    { "modelo": "C4 Tendance 2.0 Flex 16V 5p Aut.", "marca": "Citroën" },
    { "modelo": "DS3 1.6 Turbo 16V 3p Mec.", "marca": "Citroën" },
    { "modelo": "Evasion  GLX 2.0 16V", "marca": "Citroën" },
    { "modelo": "Grand C4 Picasso Intensive 1.6 TB Aut.", "marca": "Citroën" },
    { "modelo": "Jumper 2.3 15/16Lug. TB Diesel", "marca": "Citroën" },
    { "modelo": "Xantia 2.0  16V", "marca": "Citroën" },
    { "modelo": "Xsara Break Exclusive 1.6 16V 5p Aut.", "marca": "Citroën" },
    { "modelo": "ZX Cupê 16V", "marca": "Citroën" },
    { "modelo": "147 C/ CL", "marca": "Fiat" },
    { "modelo": "500 ABARTH MULTIAIR 1.4 TB 16V 3p", "marca": "Fiat" },
    { "modelo": "Bravo ABSOLUTE 1.8 Flex 16V 5p", "marca": "Fiat" },
    { "modelo": "Cinquecento 0.7", "marca": "Fiat" },
    { "modelo": "Coupe 16V", "marca": "Fiat" },
    { "modelo": "Doblo  1.4 mpi Fire Flex  8V 4p", "marca": "Fiat" },
    { "modelo": "Ducato Cargo 2.8 Curto/Longo TB Diesel", "marca": "Fiat" },
    { "modelo": "Duna 1.6ie", "marca": "Fiat" },
    { "modelo": "Elba 1.6i.e/Top/CSL/ 1.6i.e/1.5 2p e 4p", "marca": "Fiat" },
    { "modelo": "Fiorino Pick-Up Working 1.5 mpi / i.e.", "marca": "Fiat" },
    { "modelo": "FREEMONT 2.4 16V 5p Aut.", "marca": "Fiat" },
    { "modelo": "Grand Siena TETRAFUEL 1.4 Evo F. Flex 8V", "marca": "Fiat" },
    { "modelo": "Idea A.Ext./A..Ext.Loc.Dual. 1.8 Flex 5p", "marca": "Fiat" },
    { "modelo": "LINEA T-JET 1.4 16V Turbo 4p", "marca": "Fiat" },
    { "modelo": "Marea City", "marca": "Fiat" },
    { "modelo": "Marea Weekend Turbo 2.0 20V 4p", "marca": "Fiat" },
    { "modelo": "MOBI WAY on 1.0 Fire Flex 5p.", "marca": "Fiat" },
    { "modelo": "Oggi", "marca": "Fiat" },
    { "modelo": "Palio 1.0 Cel. ECON./ITALIA F.Flex 8V 4p", "marca": "Fiat" },
    { "modelo": "Palio 1.5 mpi 8V 2p", "marca": "Fiat" },
    { "modelo": "Palio 1.8R mpi Flex 8V 4p", "marca": "Fiat" },
    { "modelo": "Palio ELX 1.0 Fire/30 Anos F. Flex 8V 4p", "marca": "Fiat" },
    { "modelo": "Palio Week. Adv. Dualogic 1.8 Flex", "marca": "Fiat" },
    { "modelo": "Palio Weekend Trekking 1.8 mpi Flex 8V", "marca": "Fiat" },
    { "modelo": "Premio S 1.5 i.e./ 1.5 / 1.3", "marca": "Fiat" },
    { "modelo": "Punto  ELX 1.4 Fire Flex 8V 5p", "marca": "Fiat" },
    { "modelo": "Siena Stile/Sport MTV 1.6 mpi 16V", "marca": "Fiat" },
    { "modelo": "Siena TETRAFUEL 1.4 mpi Fire Flex 8v 4p", "marca": "Fiat" },
    { "modelo": "Stilo Duologic 1.8 ATTRACTIVE Flex 8V 5p", "marca": "Fiat" },
    { "modelo": "Strada LX 1.6 16V CE", "marca": "Fiat" },
    { "modelo": "Strada Trekking 1.8 mpi Flex 8V CS", "marca": "Fiat" },
    { "modelo": "Strada Working 1.4 mpi Fire Flex 8V CD", "marca": "Fiat" },
    { "modelo": "Tempra Turbo 2.0 i.e. 2p", "marca": "Fiat" },
    { "modelo": "Tipo 1.6 i.e. 2p e 4p", "marca": "Fiat" },
    { "modelo": "Toro Volcano 2.0 16V 4x4 TB Diesel Aut.", "marca": "Fiat" },
    { "modelo": "Uno 1.6 mpi 2p e 4p", "marca": "Fiat" },
    { "modelo": "UNO ECONOMY 1.4 EVO Fire Flex 8V 2p", "marca": "Fiat" },
    { "modelo": "Uno Furgão 1.5/ 1.3", "marca": "Fiat" },
    { "modelo": "Uno Mille/ Mille EX/ Smart 4p", "marca": "Fiat" },
    { "modelo": "UNO SPORTING Dualogic 1.4 EVO Flex 8V 4p", "marca": "Fiat" },
    { "modelo": "UNO WAY XINGU 1.4 EVO F.Flex 8V 5p", "marca": "Fiat" },
    { "modelo": "Del Rey GLX 1.6/1.8 / GL 1.6/1.8 2p e 4p", "marca": "Ford" },
    { "modelo": "EcoSport S 1.6 16V Flex 5p", "marca": "Ford" },
    { "modelo": "EDGE TITANIUM 3.5 V6 24V AWD Aut.", "marca": "Ford" },
    { "modelo": "Escort XR3 2.0i Conversível", "marca": "Ford" },
    { "modelo": "Expedition 5.4 V8", "marca": "Ford" },
    { "modelo": "Explorer XLT 4x4 4.0 V6", "marca": "Ford" },
    { "modelo": "F-1000 XLT/XL Lighting 4.9i", "marca": "Ford" },
    { "modelo": "F-250 XLT 4.2 V6", "marca": "Ford" },
    { "modelo": "Fiesta 1.0 8V Flex/Class 1.0 8V Flex 5p", "marca": "Ford" },
    { "modelo": "Fiesta Sedan TITANIUM 1.6 16V Flex Mec", "marca": "Ford" },
    { "modelo": "Focus TITANIUM 2.0 16V Flex 5p Mec.", "marca": "Ford" },
    { "modelo": "Fusion Titanium HYBRID 2.0 145cv Aut.", "marca": "Ford" },
    { "modelo": "Mondeo CLX 1.8 4p e 5p", "marca": "Ford" },
    { "modelo": "Mustang GT V8 Conversível", "marca": "Ford" },
    { "modelo": "Pampa 4x4 Jeep GL / L 1.6", "marca": "Ford" },
    { "modelo": "Ranger XLT 4.0 4x4 CS", "marca": "Ford" },
    { "modelo": "Ranger XLT Limit./L.Cent. 2.8 CD TB Dies", "marca": "Ford" },
    { "modelo": "Royale Ghia 2.0i 4p / 2.0i / 2.0", "marca": "Ford" },
    { "modelo": "Taurus GL 3.0 V6", "marca": "Ford" },
    { "modelo": "Thunderbird SC 3.8 V6", "marca": "Ford" },
    { "modelo": "TRANSIT Chassi 2.2 TDCI Diesel", "marca": "Ford" },
    { "modelo": "Verona S 2.0i 4p", "marca": "Ford" },
    { "modelo": "Versailles Ghia 2.0i / 2.0 2p e 4p", "marca": "Ford" },
    { "modelo": "AGILE LTZ WI-FI 1.4 8V FlexPower 5p", "marca": "GM - Chevrolet" },
    { "modelo": "Astra Sedan Comfort 1.8 MPFI 8V 4p", "marca": "GM - Chevrolet" },
    { "modelo": "Blazer Jimmy 4.3 V6", "marca": "GM - Chevrolet" },
    { "modelo": "Bonanza S / Luxe 4.0 Diesel Turbo", "marca": "GM - Chevrolet" },
    { "modelo": "Brasinca Blazer CD 4.1", "marca": "GM - Chevrolet" },
    { "modelo": "C-10 2.5/4.1", "marca": "GM - Chevrolet" },
    { "modelo": "Camaro Z-28 Targa/Conv. 5.7", "marca": "GM - Chevrolet" },
    { "modelo": "Caprice 4.3 V8", "marca": "GM - Chevrolet" },
    { "modelo": "CAPTIVA SPORT FWD 3.6 V6 24V 261cv 4x2", "marca": "GM - Chevrolet" },
    { "modelo": "Celta Super 1.0 MPFI 8V FlexPower 5p", "marca": "GM - Chevrolet" },
    { "modelo": "Chevette Junior 1.0", "marca": "GM - Chevrolet" },
    { "modelo": "Chevette L / SL / SL/e / DL / SE 1.6", "marca": "GM - Chevrolet" },
    { "modelo": "Chevy 500 DL / SL / SE/ Furgão 1.6", "marca": "GM - Chevrolet" },
    { "modelo": "Cheynne 4.3 V6", "marca": "GM - Chevrolet" },
    { "modelo": "Classic ADVANTAGE 1.0 VHC FlexPower 4p", "marca": "GM - Chevrolet" },
    { "modelo": "Classic/ Classic LS 1.0 VHC FlexPower 4p", "marca": "GM - Chevrolet" },
    { "modelo": "COBALT LTZ 1.8 8V Econo.Flex 4p Mec.", "marca": "GM - Chevrolet" },
    { "modelo": "Corsa Furgão 1.6 MPFi Powertech 92cv", "marca": "GM - Chevrolet" },
    { "modelo": "Corsa Wind Piquet/ Champ 1.0 MPFI 2p", "marca": "GM - Chevrolet" },
    { "modelo": "Corvette 5.7/ 6.0, 6.2 Conv./Stingray", "marca": "GM - Chevrolet" },
    { "modelo": "Corvette 5.7/ 6.0, 6.2 Targa/Stingray", "marca": "GM - Chevrolet" },
    { "modelo": "CRUZE LTZ 1.8 16V FlexPower 4p Aut.", "marca": "GM - Chevrolet" },
    { "modelo": "D-10 CD Diesel", "marca": "GM - Chevrolet" },
    { "modelo": "Kadett Sport 2.0 MPFI / EFI", "marca": "GM - Chevrolet" },
    { "modelo": "Lumina", "marca": "GM - Chevrolet" },
    { "modelo": "Meriva SS EASYTRONIC 1.8 FlexPower 5p", "marca": "GM - Chevrolet" },
    { "modelo": "MONTANA  Sport 1.8 MPFI FlexPower 8V", "marca": "GM - Chevrolet" },
    { "modelo": "Monza 1.6i/ 1.8i  (restante)", "marca": "GM - Chevrolet" },
    { "modelo": "Monza Class 1.8/ 2.0", "marca": "GM - Chevrolet" },
    { "modelo": "Omega CD 3.8 V6", "marca": "GM - Chevrolet" },
    { "modelo": "ONIX  Lollapalooza 1.0 F.Power 5p Mec.", "marca": "GM - Chevrolet" },
    { "modelo": "Opala Comodoro/ Comod. SLE  4.1 / 2.5", "marca": "GM - Chevrolet" },
    { "modelo": "PRISMA  Sed. Maxx/ LT 1.4 8V ECONOF. 4p", "marca": "GM - Chevrolet" },
    { "modelo": "S10 Blazer  DTi 2.8 4x2 Turbo Diesel", "marca": "GM - Chevrolet" },
    { "modelo": "SONIC HB LT 1.6 16V FlexPower 5p Aut.", "marca": "GM - Chevrolet" },
    { "modelo": "SpaceVan Furgão 2.1 Diesel", "marca": "GM - Chevrolet" },
    { "modelo": "SPIN ACTIV 1.8 8V Econo. Flex 5p Aut.", "marca": "GM - Chevrolet" },
    { "modelo": "Vectra CD 2.0 (modelo antigo)", "marca": "GM - Chevrolet" },
    { "modelo": "Zafira 2.0/ CD 2.0  8V  MPFI 5p Mec.", "marca": "GM - Chevrolet" },
    { "modelo": "Accord Coupe EX", "marca": "Honda" },
    { "modelo": "Civic Hatch DX", "marca": "Honda" },
    { "modelo": "Civic Sed LX 1.8 Aut 4p(s/Acess.Esp.D.F)", "marca": "Honda" },
    { "modelo": "CR-V 2.0 16V Aut.", "marca": "Honda" },
    { "modelo": "HR-V EX 1.8 Flexone 16V 5p Aut.", "marca": "Honda" },
    { "modelo": "Accent GLS 1.5 12/16V Aut.", "marca": "Hyundai" },
    { "modelo": "Coupê FX 2.0 Aut.", "marca": "Hyundai" },
    { "modelo": "Elantra GLS 2.0 16V Aut", "marca": "Hyundai" },
    { "modelo": "HB20 C./C.Plus/C.Style 1.6 Flex 16V Mec.", "marca": "Hyundai" },
    { "modelo": "HB20S  Impress 1.6 Flex 16V Aut.", "marca": "Hyundai" },
    { "modelo": "HB20X Premium 1.6 Flex 16V Aut.", "marca": "Hyundai" },
    { "modelo": "Santa Fé /GLS 3.3 V6 4X4 Tiptronic", "marca": "Hyundai" },
    { "modelo": "Sonata 2.4 16V 182cv 4p Aut.", "marca": "Hyundai" },
    { "modelo": "Tucson 2.0 16V Aut.", "marca": "Hyundai" },
    { "modelo": "Besta EST 2.7 Diesel (10/12lug.)", "marca": "Kia Motors" },
    { "modelo": "Bongo K-2400 2.4 Diesel", "marca": "Kia Motors" },
    { "modelo": "Carnival GS 2.9 TDI 16V 125cv Diesel", "marca": "Kia Motors" },
    { "modelo": "Cerato 1.6 16 V Flex Mec.", "marca": "Kia Motors" },
    { "modelo": "Picanto EX 1.1/ 1.0/ 1.0 Flex Aut", "marca": "Kia Motors" },
    { "modelo": "Sorento 2.4 16V 174cv 4x2 Aut.", "marca": "Kia Motors" },
    { "modelo": "Sportage 2.0 8V TB-IC Diesel", "marca": "Kia Motors" },
    { "modelo": "C-200 Classic/Sport", "marca": "Mercedes-Benz" },
    { "modelo": "Classe A 160 Classic Semi-Aut.", "marca": "Mercedes-Benz" },
    { "modelo": "Classe B 170 1.7 116cv Aut.", "marca": "Mercedes-Benz" },
    { "modelo": "CLK-230 Cabriolet Kompressor", "marca": "Mercedes-Benz" },
    { "modelo": "CLS-63 AMG 6.2 V8 32V 514cv", "marca": "Mercedes-Benz" },
    { "modelo": "GLK 220 CDI 2.2 TB 4X4 170cv Aut. Diesel", "marca": "Mercedes-Benz" },
    { "modelo": "ML-230 4x4", "marca": "Mercedes-Benz" },
    { "modelo": "SL-280 Classic 2.8", "marca": "Mercedes-Benz" },
    { "modelo": "SLK-320 3.2 218cv", "marca": "Mercedes-Benz" },
    { "modelo": "Sprinter 310 Chassi Diesel", "marca": "Mercedes-Benz" },
    { "modelo": "ASX 2.0 16V  4x4 Aut.(By Armura-Blind.)", "marca": "Mitsubishi" },
    { "modelo": "ASX 2.0 16V 160cv Aut.", "marca": "Mitsubishi" },
    { "modelo": "Eclipse GS/ GS Turbo Mec", "marca": "Mitsubishi" },
    { "modelo": "L200 2.5 4x2 CD Turbo Diesel", "marca": "Mitsubishi" },
    { "modelo": "Lancer 2.0 16V 160cv Aut.", "marca": "Mitsubishi" },
    { "modelo": "OUTLANDER 2.0 16V 160cv Aut.", "marca": "Mitsubishi" },
    { "modelo": "Pajero 3.2 4x4 T.I. Dies. 5p Aut", "marca": "Mitsubishi" },
    { "modelo": "Space Wagon GLS 2.0", "marca": "Mitsubishi" },
    { "modelo": "Space Wagon GLS 2.4", "marca": "Mitsubishi" },
    { "modelo": "Space Wagon GLXi 2.4 ( Nova Série )", "marca": "Mitsubishi" },
    { "modelo": "Space Wagon/ Glxi 2.4", "marca": "Mitsubishi" },
    { "modelo": "350Z 3.5 V6 280cv/ 312cv 2p", "marca": "Nissan" },
    { "modelo": "Altima GXE 2.4 16V", "marca": "Nissan" },
    { "modelo": "Altima SE 2.4 16V", "marca": "Nissan" },
    { "modelo": "ALTIMA SL 2.5 16V 4p Aut.", "marca": "Nissan" },
    { "modelo": "AX 6.5D Turbo Diesel", "marca": "Nissan" },
    { "modelo": "D-21 Pick-Up CD 4x2/4x4 2.7 Diesel", "marca": "Nissan" },
    { "modelo": "D-21 Pick-Up CS 4x2/4x4 2.7 Diesel", "marca": "Nissan" },
    { "modelo": "Frontier AX 3.2 CD Diesel", "marca": "Nissan" },
    { "modelo": "Infinit 3.0", "marca": "Nissan" },
    { "modelo": "KICKS Rio 2016 1.6 16V FlexStar 5p Aut.", "marca": "Nissan" },
    { "modelo": "KICKS SL 1.6 16V FlexStar 5p Aut.", "marca": "Nissan" },
    { "modelo": "King-Cab SE 4x4 3.0 V6", "marca": "Nissan" },
    { "modelo": "MARCH 1.0 12V Flex 5p", "marca": "Nissan" },
    { "modelo": "Pathfinder LE 2.5 16V TDI Diesel Aut", "marca": "Nissan" },
    { "modelo": "Sentra 2.0/ 2.0 Flex Fuel 16V Aut.", "marca": "Nissan" },
    { "modelo": "TIIDA S 1.8/1.8 Flex 16V  Mec.", "marca": "Nissan" },
    { "modelo": "VERSA 1.0 12V FlexStart 4p Mec.", "marca": "Nissan" },
    { "modelo": "XTerra XE 4x4 2.8 132cv TB Int. Diesel", "marca": "Nissan" },
    { "modelo": "X-TRAIL GX 2.5 16V 180cv 5p", "marca": "Nissan" },
    { "modelo": "205 CJ Cabriolet", "marca": "Peugeot" },
    { "modelo": "207 Active 1.4 Flex 8V 5p", "marca": "Peugeot" },
    { "modelo": "208 Active 1.2 Flex 12V 5p mec.", "marca": "Peugeot" },
    { "modelo": "306 Cabriolet 1.8/ Mi 16V", "marca": "Peugeot" },
    { "modelo": "307 SW Feline 2.0 16V 5p Aut.", "marca": "Peugeot" },
    { "modelo": "508 THP 1.6 Turbo 16V 4p Aut.", "marca": "Peugeot" },
    { "modelo": "Boxer 2.3 Furg.TB Dies. Curto/Médio", "marca": "Peugeot" },
    { "modelo": "HOGGAR Active 1.4 Flex 8V 2p", "marca": "Peugeot" },
    { "modelo": "Clio Auth. /AIR Hi-Flex 1.6 16V 5p", "marca": "Renault" },
    { "modelo": "DUSTER 1.6 Hi-Flex 16V Mec", "marca": "Renault" },
    { "modelo": "Express 1.6/ RL 1.6", "marca": "Renault" },
    { "modelo": "FLUENCE Sed. Dyn. Plus 2.0 16V FLEX Aut.", "marca": "Renault" },
    { "modelo": "Kangoo Authentique 1.6 16V 95cv", "marca": "Renault" },
    { "modelo": "Laguna Grand Tour Privilège 3.0 V6 210cv", "marca": "Renault" },
    { "modelo": "LOGAN Authentique Hi-Flex 1.0 16V 4p", "marca": "Renault" },
    { "modelo": "Master 2.3 dCi Chassi 16V Diesel", "marca": "Renault" },
    { "modelo": "Megane Grand Tour Dynam. Hi-Flex 1.6 16V", "marca": "Renault" },
    { "modelo": "Megane Sed. Expression 2.0 16V Aut.", "marca": "Renault" },
    { "modelo": "SANDERO Auth. Plus Hi-Power 1.0 16V 5p", "marca": "Renault" },
    { "modelo": "Scénic RXE 2.0 8V", "marca": "Renault" },
    { "modelo": "Twingo Easy 1.2", "marca": "Renault" },
    { "modelo": "Grand Vitara 1.6 16V Aut.", "marca": "Suzuki" },
    { "modelo": "Swift GL", "marca": "Suzuki" },
    { "modelo": "SX4 2.0 16V 145cv 4WD 5p Aut.", "marca": "Suzuki" },
    { "modelo": "Vitara JLX Metal 1.6 8V 2p", "marca": "Suzuki" },
    { "modelo": "Corolla ALTIS 2.0 Flex 16V Aut.", "marca": "Toyota" },
    { "modelo": "Corolla DX/ SW DX 1.6 16V", "marca": "Toyota" },
    { "modelo": "ETIOS 1.3 Flex 16V 5p Mec.", "marca": "Toyota" },
    { "modelo": "Hilux 4x2 2.4 Diesel", "marca": "Toyota" },
    { "modelo": "Land Cruiser 4WD 4.5 24V", "marca": "Toyota" },
    { "modelo": "PRIUS HYBRID 1.8 16V 5p Aut.", "marca": "Toyota" },
    { "modelo": "RAV4 2.0 4x2 16V Aut.", "marca": "Toyota" },
    { "modelo": "Supra", "marca": "Toyota" },
    { "modelo": "T-100 3.4 V6", "marca": "Toyota" },
    { "modelo": "440 Turbo 1.8", "marca": "Volvo" },
    { "modelo": "S80 3.2 238cv Aut.", "marca": "Volvo" },
    { "modelo": "V60 T-5 MOMENTUM 2.0 245cv 5p", "marca": "Volvo" },
    { "modelo": "AMAROK CD2.0 16V/S CD2.0 16V TDI 4x2 Die", "marca": "VW - VolksWagen" },
    { "modelo": "Bora 2.0 8v Comfortline Aut.", "marca": "VW - VolksWagen" },
    { "modelo": "CROSSFOX  1.6 T. Flex 16V 5p", "marca": "VW - VolksWagen" },
    { "modelo": "EOS Cab. 2.0 Turbo FSI Tiptronic", "marca": "VW - VolksWagen" },
    { "modelo": "Eurovan 2.4 Diesel", "marca": "VW - VolksWagen" },
    { "modelo": "Fox 1.0 Mi Total Flex 8V 3p", "marca": "VW - VolksWagen" },
    { "modelo": "Fusca", "marca": "VW - VolksWagen" },
    { "modelo": "Fusca 2.0 TSI 16V Mec.", "marca": "VW - VolksWagen" },
    { "modelo": "Gol (novo) 1.0 Mi Total Flex 8V 2p", "marca": "VW - VolksWagen" },
    { "modelo": "Gol TSi 2000 2p e 4p", "marca": "VW - VolksWagen" },
    { "modelo": "Golf  BLACK EDITON 2.0 Mi T. Flex 8V Tip", "marca": "VW - VolksWagen" },
    { "modelo": "Grand Saveiro Xtreme/Street  1.6/1.8/2.0", "marca": "VW - VolksWagen" },
    { "modelo": "JETTA  GLX III 2.8 VR6", "marca": "VW - VolksWagen" },
    { "modelo": "Kombi Carat", "marca": "VW - VolksWagen" },
    { "modelo": "Logus 1.6 / CLi / CL/ GL", "marca": "VW - VolksWagen" },
    { "modelo": "New Beetle 2.0 Mi Mec./Aut.", "marca": "VW - VolksWagen" },
    { "modelo": "Parati 1.0 Mi FUN/ SunSet 16V 4p", "marca": "VW - VolksWagen" },
    { "modelo": "Passat  L/LS/LSe/GL/GLS/TS/Fla/Vill/Plus", "marca": "VW - VolksWagen" },
    { "modelo": "Passat VR6 2.8", "marca": "VW - VolksWagen" },
    { "modelo": "Pointer 1.8 / CLi", "marca": "VW - VolksWagen" },
    { "modelo": "Polo 1.0 Mi 79cv 16V 5p", "marca": "VW - VolksWagen" },
    { "modelo": "Quantum 1.8 Mi/ 1.8i", "marca": "VW - VolksWagen" },
    { "modelo": "Santana 1.8 Mi", "marca": "VW - VolksWagen" },
    { "modelo": "Saveiro  Trendline 1.6 T.Flex 8V", "marca": "VW - VolksWagen" },
    { "modelo": "SpaceCross I MOTION 1.6 Mi Total Flex 8V", "marca": "VW - VolksWagen" },
    { "modelo": "SPACEFOX  SPORTLINE/HIGHLINE 1.6 T.Flex", "marca": "VW - VolksWagen" },
    { "modelo": "up! black/white/red 1.0 T. Flex 12V 5p", "marca": "VW - VolksWagen" },
    { "modelo": "VOYAGE Trendline 1.0 T.Flex 12V 4p", "marca": "VW - VolksWagen" },
    { "modelo": "145 Elegant 1.7/1.8 16V", "marca": "Alfa Romeo" },
    { "modelo": "145 Elegant 2.0 16V", "marca": "Alfa Romeo" },
    { "modelo": "156 SportWagon 2.5 V6 24V 190cv 4p Aut.", "marca": "Alfa Romeo" },
    { "modelo": "Celer Hatch 1.5 16V Flex 5p", "marca": "CHERY" },
    { "modelo": "Celer Sedan ACT 1.5 16V Flex 5p", "marca": "CHERY" },
    { "modelo": "CIELO 1.6 16V 119cv  5p", "marca": "CHERY" },
    { "modelo": "CIELO Sedan 1.6 16V 119cv  4p", "marca": "CHERY" },
    { "modelo": "Face 1.3 16V/1.3 16v Flex.Mec", "marca": "CHERY" },
    { "modelo": "QQ 1.0 ACT 12V 69cv 5p", "marca": "CHERY" },
    { "modelo": "QQ 1.0 ACT FL 12V 69cv 5p", "marca": "CHERY" },
    { "modelo": "QQ 1.0 Look FL 12V 69cv 5p", "marca": "CHERY" },
    { "modelo": "QQ 1.1/1.0 12V 69cv 5p", "marca": "CHERY" },
    { "modelo": "S-18 1.3 16V Flex Mec. 5p", "marca": "CHERY" },
    { "modelo": "Tiggo 2.0 16V Aut. 5p", "marca": "CHERY" },
    { "modelo": "Tiggo 2.0 16V Mec. 5p", "marca": "CHERY" },
    { "modelo": "Caravan LE  3.3", "marca": "Chrysler" },
    { "modelo": "Grand Caravan LE 3.3 Aut", "marca": "Chrysler" },
    { "modelo": "PT Cruiser Cabrio 2.4 16V 143cv 2p", "marca": "Chrysler" },
    { "modelo": "Dakota 2.5", "marca": "Dodge" },
    { "modelo": "JOURNEY Crossroad 3.6 V6 Aut.", "marca": "Dodge" },
    { "modelo": "Ram 2500 TROPIVAN 5.9 SLT TDI 4x4 Dies.", "marca": "Dodge" },
    { "modelo": "456 GTA", "marca": "Ferrari" },
    { "modelo": "BR-800 (todos)/ Supermini", "marca": "Gurgel" },
    { "modelo": "J2 1.4 16V 5p Mec.", "marca": "JAC" },
    { "modelo": "J2 1.4 JET Flex 16V 5p Mec", "marca": "JAC" },
    { "modelo": "J3 1.4 16V 5p Mec.", "marca": "JAC" },
    { "modelo": "J5 Sedan 1.5 16V 4p Mec.", "marca": "JAC" },
    { "modelo": "J6 2.0 16V 5p Mec.", "marca": "JAC" },
    { "modelo": "T 140 2.8 2p (diesel)", "marca": "JAC" },
    { "modelo": "T5 1.5 JET Flex 16V 5p Mec.", "marca": "JAC" },
    { "modelo": "T6 2.0 JET Flex 5p Mec.", "marca": "JAC" },
    { "modelo": "T8 2.0 16V 5p Mec.", "marca": "JAC" },
    { "modelo": "XJ-8 Executive/ Centenary 4.0", "marca": "Jaguar" },
    { "modelo": "Cherokee Sport 2.5 4x4 Diesel", "marca": "Jeep" },
    { "modelo": "Grand Cherokee Laredo 2.7 I-5 TB Dies.", "marca": "Jeep" },
    { "modelo": "Grand Cherokee SRT8 6.1 V8 16V 432cv Aut", "marca": "Jeep" },
    { "modelo": "Renegade 75 Anos 1.8 4X2 Flex 16V Aut.", "marca": "Jeep" },
    { "modelo": "Renegade1.8 4x2 Flex 16V Mec.", "marca": "Jeep" },
    { "modelo": "Wrangler 4.0/Sport 4.0", "marca": "Jeep" },
    { "modelo": "HURACAN Coupe LP 610-4", "marca": "LAMBORGHINI" },
    { "modelo": "Defender 110 2.4 122cv T.Diesel", "marca": "Land Rover" },
    { "modelo": "Defender 90 TDI Hard Top Diesel", "marca": "Land Rover" },
    { "modelo": "Discovery3 HSE 4.4 V8 4x4 299cv Aut.", "marca": "Land Rover" },
    { "modelo": "Discovery4 HSE 2.7 4x4 TDV6 Diesel Aut.", "marca": "Land Rover" },
    { "modelo": "Range R. EVO DYNAMIQUE BLACK 2.0 Aut. 5p", "marca": "Land Rover" },
    { "modelo": "Range Rover EVOQUE Zanzibar 2.0 Aut. 5p", "marca": "Land Rover" },
    { "modelo": "Range Rover SUPERCHAGED 4.2 V8 396cv", "marca": "Land Rover" },
    { "modelo": "Range Rover Vogue 3.0 TDV6 Diesel Aut.", "marca": "Land Rover" },
    { "modelo": "COOPER PACEMAN S John Works ALL4 1.6 Aut", "marca": "MINI" },
    { "modelo": "COOPER S BAYSWATER 1.6 Aut.", "marca": "MINI" },
    { "modelo": "COOPER S Clubman 1.6 Aut.", "marca": "MINI" },
    { "modelo": "ONE 1.6 Aut.", "marca": "MINI" },
    { "modelo": "Picape BG-Truck CD Turbo Diesel", "marca": "Miura" },
    { "modelo": "Boxster Spyder 3.4 320cv", "marca": "Porsche" },
    { "modelo": "Cayenne S 4.5/4.8", "marca": "Porsche" },
    { "modelo": "Cayman S 3.4", "marca": "Porsche" },
    { "modelo": "Mini Cooper 1.3", "marca": "Rover" },
    { "modelo": "ACTYON 2.3 16V 150cv Aut.", "marca": "SSANGYONG" },
    { "modelo": "Forester 2.0 16v 4x4 Turbo Aut.", "marca": "Subaru" },
    { "modelo": "XV 2.0 16V 4x4 150cv Aut.", "marca": "Subaru" },
    { "modelo": "PANTANAL 3.0 TDI Elet. 4x2 CS Diesel", "marca": "Troller" },
    { "modelo": "RF Esport 4x4 2.0", "marca": "Troller" },
    { "modelo": "T-4 DESERT STORM 4x4 3.0 TB Int Diesel", "marca": "Troller" }
];
//# sourceMappingURL=veiculos.js.map